import { Link } from '@mui/material';
import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import CloseButton from 'react-bootstrap/CloseButton';

export const AnnouncementBanner = (props) => {
  const keyName = 'announcement-hide';
  const keyValue = '2025-07';

  const [showAlert, setShowAlert] = useState(() => sessionStorage.getItem(keyName) !== keyValue);
  const [enableAlert] = useState(() => props.enableAlert !== false);

  const handleAlertClose = () => {
    sessionStorage.setItem(keyName, keyValue);
    setShowAlert(false);
  };

  if (showAlert && enableAlert)
    return (
      <div className='ahrq-alert'>
        <Container>
          <div>
            Your Voice Can Shape the Future of AHRQ Quality Indicators -{' '}
            <Link to='/announcements/2025/07' aria-label='Announcements'>
              Take our Survey
            </Link>
            {'.'}
          </div>
          <CloseButton onClick={() => handleAlertClose()} aria-label='warning close' />
        </Container>
      </div>
    );

  return null;
};
